export function buildDeviceConfiguration(credentials, twin) {
  if (!credentials?.mqttPassword || !credentials?.mqtt?.endpoint || !credentials?.mqtt?.username) throw new Error("TWIN_DEVICE_CREDENTIALS_INCOMPLETE");
  return {
    specVersion: credentials.specVersion,
    generatedAt: credentials.rotatedAt,
    objectid: {
      network: credentials.network,
      tenantId: credentials.tenantId,
      subscriptionId: credentials.subscriptionId,
    },
    twin: { id: twin.id, name: twin.name, type: twin.type },
    mqtt: {
      endpoint: credentials.mqtt.endpoint,
      clientId: credentials.mqtt.username,
      username: credentials.mqtt.username,
      password: credentials.mqttPassword,
      topics: credentials.mqtt.topics,
    },
  };
}

export function deviceConfigurationFilename(twinId) {
  return `objectid-twin-${String(twinId).replace(/^0x/, "").slice(0, 8)}.json`;
}
